import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RelatedProductsComponentDef } from '@df/catalog-ui/related-products/related-products.component.def';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { DfModuleGtmModule } from '@df/module-gtm/df-module-gtm.module';
import { ProductComponent } from '../../product/product.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Product } from '../../product.decorator';
import { IProductDataV2 } from '@df/catalog/product/product';
let uid = 0;
@Component({
    selector: 'product-view-related-carousel',
    templateUrl: './product-view-related-carousel.html',
    styleUrl: './product-view-related-carousel.scss',
    imports: [DfUiCarouselModule, CommonModule, ProductComponent, DfModuleGtmModule, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewRelatedCarouselComponent<
    T extends Product<IProductDataV2> = Product<IProductDataV2>
> extends RelatedProductsComponentDef<T> {
    @Input()
    title: string = '';

    protected uid = `product-view-related-carousel-${uid++}`;

    get pcSlides(): number {
        return [1.64, 1.64, 3.48, 3.48][this.client.sizeId];
    }

    get pcSlidesCeil(): number {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter(): string {
        return '16px';
    }
}
